<ion-app>
  <!-- <my-side-menu-mobile contentId="myContent"></my-side-menu-mobile> -->
  <my-side-menu-desktop contentId="myContent"></my-side-menu-desktop>
  <ion-router-outlet id="myContent"></ion-router-outlet>
</ion-app>